var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSantong(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame 15",
    clipPath: "url(#clip0_30_663)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.68563 8.25618L0.382051 9.92315L0.384884 9.92877L0.368774 9.93691L2.67411 14.4951L6.49941 12.5604C7.21936 12.1963 8.06904 12.1938 8.79115 12.5536L9.3131 12.8137L9.33384 12.8241L12.6322 14.47L14.913 9.89953L14.8988 9.89242L14.8997 9.89048L11.6019 8.24714C10.743 7.81257 10.201 6.93164 10.201 5.9683L10.201 2.19664L10.197 2.19664V2.17993H5.08906L5.08906 5.97603C5.08906 6.94004 4.54627 7.82191 3.68563 8.25618Z",
    stroke: "black",
    strokeWidth: 1.0216
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 3",
    x: 4.83365,
    y: 2.2554,
    width: 5.61878,
    height: 0.510798,
    fill: "#D9D9D9",
    stroke: "black",
    strokeWidth: 0.510798
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 4",
    x: 0.708077,
    y: 9.64412,
    width: 5.41328,
    height: 0.452096,
    transform: "rotate(63.6954 0.708077 9.64412)",
    fill: "#D9D9D9",
    stroke: "black",
    strokeWidth: 0.452096
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 5",
    x: 15.0903,
    y: 9.767,
    width: 5.43807,
    height: 0.474956,
    transform: "rotate(116.559 15.0903 9.767)",
    fill: "#D9D9D9",
    stroke: "black",
    strokeWidth: 0.474956
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_30_663"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSantong);
export default __webpack_public_path__ + "static/media/santong.638fe6780a0e1006c06dc13c6f1d1839.svg";
export { ForwardRef as ReactComponent };